import { motion } from "framer-motion";
import { Phone, WhatsappLogo } from "@phosphor-icons/react";
import { SITE, WA_LINK } from "@/constants/site";
import LeadForm from "./LeadForm";

export default function EnquirySection({ configuration, onConfigurationChange, project, onProjectClear }) {
  return (
    <section id="enquire" data-testid="enquiry-section" className="bg-sand py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 md:grid-cols-12 lg:gap-16 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="flex flex-col justify-center md:col-span-5"
        >
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-forest/70">Enquire</p>
          <h2 className="mt-4 font-serif text-2xl tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
            Book your private viewing
          </h2>
          <p className="mt-6 text-base leading-relaxed text-slate-600">
            Share your details and our Shantigram specialist will call you back with current availability, pricing and
            floor plans — plus a guided site visit at a time that suits you.
          </p>
          <div className="mt-10 space-y-4">
            <a
              href={`tel:${SITE.phoneRaw}`}
              data-testid="enquiry-call-link"
              className="flex items-center gap-4 rounded-sm border border-forest/15 bg-white p-4 transition-colors duration-200 hover:border-gold"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-sm bg-forest text-gold">
                <Phone size={20} weight="fill" />
              </span>
              <span>
                <span className="block text-xs uppercase tracking-widest text-slate-400">Call us</span>
                <span className="block font-semibold text-slate-900">{SITE.phoneDisplay}</span>
              </span>
            </a>
            <a
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="enquiry-whatsapp-link"
              onClick={() => window.fbq && window.fbq("track", "Contact")}
              className="flex items-center gap-4 rounded-sm border border-forest/15 bg-white p-4 transition-colors duration-200 hover:border-gold"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-sm bg-[#25D366] text-white">
                <WhatsappLogo size={20} weight="fill" />
              </span>
              <span>
                <span className="block text-xs uppercase tracking-widest text-slate-400">WhatsApp</span>
                <span className="block font-semibold text-slate-900">Chat instantly</span>
              </span>
            </a>
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="md:col-span-7"
        >
          <LeadForm
            configuration={configuration}
            onConfigurationChange={onConfigurationChange}
            project={project}
            onProjectClear={onProjectClear}
          />
        </motion.div>
      </div>
    </section>
  );
}
